import api from './api';

// Pipelines
export const getCrmPipelines = () => api.get('/crm/pipelines');
// Lista enxuta (id + título) para seletores — padrão /xxx/options.
export const getCrmPipelineOptions = () => api.get('/crm/pipelines/options');
export const createCrmPipeline = (data) => api.post('/crm/pipelines', data);
export const updateCrmPipeline = (id, data) => api.put(`/crm/pipelines/${id}`, data);
export const deleteCrmPipeline = (id) => api.delete(`/crm/pipelines/${id}`);
export const updateCrmPipelineStages = (id, stages) =>
  api.put(`/crm/pipelines/${id}/stages`, { stages });

// Metas (configuração)
export const getCrmGoals = (params) => api.get('/crm/goals', { params });
export const saveCrmGoals = (data) => api.put('/crm/goals', data);
export const getTeamGoalProgress = () => api.get('/crm/goals/team-progress');

// Opportunities
export const testCrmAutomation = (id, target) => api.post(`/crm/automations/${id}/test`, target);

export const getCrmOpportunities = (params) => api.get('/crm/opportunities', { params });
export const getCrmOpportunitiesSummary = (params) =>
  api.get('/crm/opportunities/summary', { params });
export const getCrmOpportunitiesStageSummary = (params) =>
  api.get('/crm/opportunities/stage-summary', { params });
export const getCrmOpportunity = (id) => api.get(`/crm/opportunities/${id}`);
export const createCrmOpportunity = (data) => api.post('/crm/opportunities', data);
export const updateCrmOpportunity = (id, data) => api.put(`/crm/opportunities/${id}`, data);
export const deleteCrmOpportunity = (id, data) => api.delete(`/crm/opportunities/${id}`, { data });
export const permanentDeleteCrmOpportunity = (id) =>
  api.delete(`/crm/opportunities/${id}/permanent`);
export const restoreCrmOpportunity = (id) => api.post(`/crm/opportunities/${id}/restore`);
export const getCrmOpportunityActivities = (id) => api.get(`/crm/opportunities/${id}/activities`);
export const getCrmOpportunityAttachments = (id) => api.get(`/crm/opportunities/${id}/attachments`);
export const addCrmOpportunityNote = (id, data) => api.post(`/crm/opportunities/${id}/notes`, data);
export const addCrmOpportunityAttachment = (id, formData, config) =>
  api.post(`/crm/opportunities/${id}/attachments`, formData, config);
export const deleteCrmOpportunityAttachment = (opportunityId, attId) =>
  api.delete(`/crm/opportunities/${opportunityId}/attachments/${attId}`);
export const addCrmOpportunityService = (id, data) =>
  api.post(`/crm/opportunities/${id}/services`, data);
export const deleteCrmOpportunityService = (opportunityId, serviceId) =>
  api.delete(`/crm/opportunities/${opportunityId}/services/${serviceId}`);
export const addCrmOpportunityProduct = (id, data) =>
  api.post(`/crm/opportunities/${id}/products`, data);
export const updateCrmOpportunityProduct = (opportunityId, productId, data) =>
  api.put(`/crm/opportunities/${opportunityId}/products/${productId}`, data);
export const deleteCrmOpportunityProduct = (opportunityId, productId) =>
  api.delete(`/crm/opportunities/${opportunityId}/products/${productId}`);
export const getCrmOpportunitiesTrash = () => api.get('/crm/opportunities/trash');
export const openTicketForContact = (contactId) =>
  api.post(`/tickets/open-for-contact/${contactId}`);

// Automations
export const getCrmAutomations = () => api.get('/crm/automations');
export const getCrmAutomation = (id) => api.get(`/crm/automations/${id}`);
export const createCrmAutomation = (data) => api.post('/crm/automations', data);
export const updateCrmAutomation = (id, data) => api.put(`/crm/automations/${id}`, data);
export const deleteCrmAutomation = (id) => api.delete(`/crm/automations/${id}`);

/**
 * Sobe o arquivo de uma ação de gatilho.
 *
 * `typeArch` e `fileId` definem a pasta (`company{N}/automations/<grupo>/`) —
 * é o mecanismo do `config/upload.ts`. O grupo agrupa por ação, para apagar o
 * gatilho poder apagar a pasta inteira.
 */
export const uploadAutomationMedia = (arquivo, { grupo, contentType }) => {
  const formData = new FormData();
  formData.append('file', arquivo);
  formData.append('typeArch', 'automations');
  formData.append('fileId', grupo);
  formData.append('contentType', contentType);
  return api.post('/crm/automations/media-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteAutomationMedia = (path) =>
  api.delete('/crm/automations/media', { data: { path } });

// Settings
export const getCrmSettings = () => api.get('/crm/settings');
export const updateCrmSettings = (data) => api.put('/crm/settings', data);
export const getCrmCustomFields = () => api.get('/crm/custom-fields');
export const createCrmCustomField = (data) => api.post('/crm/custom-fields', data);
export const updateCrmCustomField = (id, data) => api.put(`/crm/custom-fields/${id}`, data);
export const deleteCrmCustomField = (id) => api.delete(`/crm/custom-fields/${id}`);
export const getCrmOrigins = () => api.get('/crm/origins');
export const createCrmOrigin = (data) => api.post('/crm/origins', data);
export const deleteCrmOrigin = (id) => api.delete(`/crm/origins/${id}`);

// Clients
export const getCrmClients = (params) => api.get('/crm/clients', { params });
export const getCrmClient = (id) => api.get(`/crm/clients/${id}`);
export const createCrmClient = (data) => api.post('/crm/clients', data);
export const updateCrmClient = (id, data) => api.put(`/crm/clients/${id}`, data);
export const deleteCrmClient = (id) => api.delete(`/crm/clients/${id}`);
export const uploadCrmClientPhoto = (id, formData, config) =>
  api.post(`/crm/clients/${id}/photo`, formData, config);
export const getCrmLeads = (params) => api.get('/crm/leads', { params });
export const getChats = (params) => api.get('/chats', { params });
export const createCrmLead = (urlSuffix, data) => api.post(`/crm/leads${urlSuffix || ''}`, data);
